/// <reference types="./common.d.mts" />
import * as $app_common_cl from "../../../../app_config/app_config/content_library.mjs";
import * as $bright from "../../../../bright/bright.mjs";
import * as $data_source from "../../../../common/data/data_source.mjs";
import * as $insight from "../../../../common/data/insight.mjs";
import * as $page from "../../../../common/data/page.mjs";
import * as $user from "../../../../common/data/user.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $dropdown from "../../../../ds/ds/components/dropdown.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $pp from "../../../../ds/ds/components/profile_picture.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $cypress from "../../../../ds/ds/cypress.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $justin from "../../../../justin/justin.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { px } from "../../../../sketch/sketch/css/length.mjs";
import * as $model from "../../../data/model.mjs";
import * as $state from "../../../data/model/state.mjs";
import { State } from "../../../data/model/state.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $route from "../../../data/route.mjs";
import * as $pagination from "../../../frontend/view/components/pagination.mjs";
import * as $s from "../../../frontend/view/styles/content_library.mjs";
import * as $dropdown_styles from "../../../frontend/view/styles/dropdowns.mjs";
import * as $p_s from "../../../frontend/view/styles/pagination.mjs";
import { toList, prepend as listPrepend } from "../../../gleam.mjs";

export function state_card(color, count, status, active) {
  let content = $data_source.status_to_display(status);
  let handler = $e.on_click(
    new $msg.ContentLibrary(new $msg.UserSelectedFilter(status)),
  );
  return $s.filter_card(
    $app_common_cl.choose_settings(color, active),
    toList([handler, $cypress.data($justin.kebab_case(content) + "-card")]),
    toList([
      $s.filter_card_title(toList([]), toList([$h.text($int.to_string(count))])),
      $s.filter_card_subtitle(toList([]), toList([$h.text(content)])),
    ]),
  );
}

export function insight_state_card(color, count, kind, active) {
  let _block;
  if (kind instanceof $insight.Conflict) {
    _block = "Conflictual information";
  } else if (kind instanceof $insight.Duplicate) {
    _block = "Duplicates";
  } else {
    _block = "Irrelevant Documents";
  }
  let content = _block;
  let handler = $e.on_click(
    new $msg.ContentLibrary(new $msg.UserSelectedInsightFilter(kind)),
  );
  return $s.filter_card(
    $app_common_cl.choose_settings(color, active),
    toList([handler]),
    toList([
      $s.filter_card_title(toList([]), toList([$h.text($int.to_string(count))])),
      $s.filter_card_subtitle(toList([]), toList([$h.text(content)])),
    ]),
  );
}

function make_filters_text(model) {
  let state = $bright.state(model);
  let _block;
  let $ = state.route;
  if ($ instanceof $route.ContentLibrary) {
    let $1 = $[0];
    if ($1 instanceof $route.DataSources) {
      let _pipe = state.content_library.non_qna_sources;
      let _pipe$1 = $option.map(_pipe, (p) => { return p.total; });
      _block = $option.unwrap(_pipe$1, 0);
    } else if ($1 instanceof $route.QuestionBank) {
      let _pipe = state.content_library.qna_sources;
      let _pipe$1 = $option.map(_pipe, (p) => { return p.total; });
      _block = $option.unwrap(_pipe$1, 0);
    } else {
      _block = 0;
    }
  } else {
    _block = 0;
  }
  let len_displayed = _block;
  let _block$1;
  let $1 = state.content_library.filter_selected;
  let $2 = state.content_library.filter_tag_selected;
  let $3 = state.content_library.filter_collaborator_selected;
  if ($3 instanceof None) {
    if ($2 instanceof None) {
      if ($1 instanceof None) {
        _block$1 = false;
      } else {
        _block$1 = true;
      }
    } else {
      _block$1 = true;
    }
  } else {
    _block$1 = true;
  }
  let is_filters_active = _block$1;
  if (is_filters_active) {
    return (("Filter " + "( ") + $int.to_string(len_displayed)) + " )";
  } else {
    return "Filter";
  }
}

function content_library_filters(model) {
  let $ = $bright.state(model);
  let content_library = $.content_library;
  let organization = $.organization;
  let is_visible = content_library.filters_opened;
  return $bool.lazy_guard(
    !is_visible,
    $el.none,
    () => {
      return $l.fragment(
        toList([
          $dropdown.dropdown(
            (var0) => { return new $msg.UserSelectedFilterTagLibrary(var0); },
            toList([
              $dropdown.selected(new Some(content_library.filter_tag_selected)),
              $dropdown.show_arrow(),
              $dropdown.panel_class($dropdown_styles.spacing()),
              $dropdown.input_class(
                $css.class$(toList([$css.min_width(px(150))])),
              ),
            ]),
            listPrepend(
              (() => {
                let _pipe = $dropdown.choice("All tags", new None());
                return $dropdown.with_class(_pipe, $dropdown_styles.neutral());
              })(),
              $list.map(
                organization.tags,
                (tag) => {
                  let _pipe = $dropdown.choice(tag.name, new Some(tag));
                  return $dropdown.with_class(_pipe, $dropdown_styles.neutral());
                },
              ),
            ),
          ),
          $dropdown.dropdown(
            (var0) => {
              return new $msg.UserSelectedFilterCollaboratorLibrary(var0);
            },
            toList([
              $dropdown.selected(
                new Some(content_library.filter_collaborator_selected),
              ),
              $dropdown.show_arrow(),
              $dropdown.panel_class($dropdown_styles.spacing()),
              $dropdown.input_class(
                $css.class$(toList([$css.min_width(px(125))])),
              ),
            ]),
            listPrepend(
              (() => {
                let _pipe = $dropdown.choice("All owners", new None());
                return $dropdown.with_class(_pipe, $dropdown_styles.white());
              })(),
              $list.map(
                organization.users,
                (user) => {
                  let name = user.name;
                  let picture = user.picture;
                  let initials = user.initials;
                  let icon = $pp.from_user(picture, initials, new $pp.Medium());
                  let _pipe = $dropdown.choice(name, new Some(user));
                  let _pipe$1 = $dropdown.with_class(
                    _pipe,
                    $dropdown_styles.white(),
                  );
                  return $dropdown.with_icon(_pipe$1, icon);
                },
              ),
            ),
          ),
        ]),
      );
    },
  );
}

export function view_content_library_filters(model, upload_element) {
  let state = $bright.state(model);
  let _block;
  let $ = state.content_library.filters_opened;
  if ($) {
    _block = $button.primary;
  } else {
    _block = $button.secondary;
  }
  let button = _block;
  return $l.row(
    toList([$l.gap(32), $l.justify("space-between")]),
    toList([]),
    toList([
      $l.row(
        toList([$l.gap(16), $l.align("center")]),
        toList([]),
        toList([
          $input.input(
            toList([
              $input.placeholder("Search"),
              $input.icon($icons.magnifying_glass()),
              $input.value(state.content_library.search),
              $input.on_input(
                (var0) => { return new $msg.UserUpdatedSearch(var0); },
              ),
            ]),
          ),
          button(
            toList([$e.on_click(new $msg.UserToggledFilterLibrary())]),
            toList([
              $icons.small($icons.filters()),
              $el.text(make_filters_text(model)),
            ]),
          ),
          content_library_filters(model),
        ]),
      ),
      upload_element,
    ]),
  );
}

function make_counter_text(page, page_size, total) {
  let lower_bound = $int.to_string(page * page_size);
  let higher_bound = $int.to_string((page + 1) * page_size);
  return (((lower_bound + " — ") + higher_bound) + " on ") + (() => {
    let _pipe = total;
    return $int.to_string(_pipe);
  })();
}

export function footer(state, page) {
  if (page instanceof Some) {
    let page$1 = page[0];
    let on_select_page = (current_page) => {
      return new $msg.ContentLibrary(
        new $msg.UserSelectedContentLibraryPage(current_page),
      );
    };
    let max_page_size = state.content_library.content_library_block_page_size;
    let page_max = $model.compute_page_max(page$1.total, max_page_size);
    let page_selector_elements = $pagination.page_selector(
      page$1.page_index,
      page_max,
      on_select_page,
      false,
    );
    let counter_element = $p_s.page_selector_counter(
      toList([]),
      toList([
        $h.text(
          make_counter_text(page$1.page_index, page$1.page_size, page$1.total),
        ),
      ]),
    );
    return $table.footer(
      page$1.total <= state.content_library.content_library_block_page_size,
      toList([counter_element, page_selector_elements]),
    );
  } else {
    return $table.footer(true, toList([]));
  }
}

export function status_label(status, effect) {
  let _block;
  if (status instanceof $data_source.Pending) {
    _block = $label.current();
  } else if (status instanceof $data_source.Verified) {
    _block = $label.success();
  } else if (status instanceof $data_source.NotVerified) {
    _block = $label.neutral();
  } else if (status instanceof $data_source.Archived) {
    _block = $label.neutral();
  } else if (status instanceof $data_source.Outdated) {
    _block = $label.error();
  } else if (status instanceof $data_source.Processing) {
    _block = $label.neutral();
  } else {
    _block = $label.error();
  }
  let label = _block;
  let name = $data_source.status_to_display(status);
  return $label.label(
    toList([label, $label.on_click(effect(status)), $label.content(name)]),
  );
}
